import { render, staticRenderFns } from "./MarginListDetail.vue?vue&type=template&id=471ec732&scoped=true"
import script from "./MarginListDetail.vue?vue&type=script&lang=js"
export * from "./MarginListDetail.vue?vue&type=script&lang=js"
import style0 from "./MarginListDetail.vue?vue&type=style&index=0&id=471ec732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471ec732",
  null
  
)

export default component.exports